import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Subject, takeUntil } from 'rxjs';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { IdmApiService, UserUtilityService } from 'src/app/services';
import { MaterialModule } from 'src/app/shared/material.module';
import { Approval } from 'src/app/Modules/settings/models/common/setting-area.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApproveActionsModalComponent } from '../approve-actions-modal/approve-actions-modal.component';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-approval-request',
    templateUrl: './approval-request.component.html',
    styleUrl: './approval-request.component.scss',
    standalone: false
})
export class ApprovalRequestComponent {
    @Output() updateList = new EventEmitter<any>();
    displayedColumns: string[] = ['initiator', 'trigger', 'startDate', 'name', 'item', 'action', 'actions'];
    dataSource = new MatTableDataSource([]);
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatTable) table: MatTable<any>;
    tooltip_position = 'above';
    isviewApprovals: boolean;
    iseditApprovals: boolean;
    isDeleteApprovalsvisible: boolean;
    @Input() pendingApprovalList: Approval[] = [];

    constructor(
        private user_utility: UserUtilityService,
        private idmApiService: IdmApiService,
        private cd: ChangeDetectorRef,
        private modelService: NgbModal,
        private customToastService: CustomToastService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private transLocoService: TranslocoService
    ) {}

    async ngOnInit(): Promise<void> {
        this.iseditApprovals = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-approvals', userActions.Edit);
        this.isDeleteApprovalsvisible = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-approvals', userActions.Delete);
        this.isviewApprovals = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-approvals', userActions.View);
        // this.LoadApprovals();

        let sortedArray = [...this.pendingApprovalList].sort((a, b) => b.startDate - a.startDate);
        this.dataSource = new MatTableDataSource(sortedArray);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.cd.detectChanges();
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes['pendingApprovalList'] && this.pendingApprovalList) {
            const sortedArray = [...this.pendingApprovalList].sort((a, b) => b.startDate - a.startDate);
            this.dataSource.data = sortedArray;
        }
    }
    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
    }
    approveAction(data: any, type: number) {
        let displayData = {
            title:
                type == 1
                    ? this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.APPROVE_A') + ' ' + data?.type
                    : type == 2
                      ? this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.REJECT_A') + ' ' + data?.type
                      : this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.ACKNOWLEDGE_A') + ' ' + data?.type,
            label1:
                type == 1
                    ? this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.PLEASE_PROVIDE_A_VALID_REASON_TO_APPROVE_THIS_ITEM')
                    : type == 2
                      ? this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.PLEASE_PROVIDE_A_VALID_REASON_TO_REJECT_THIS_ITEM')
                      : '',
            label2:
                type == 1
                    ? this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.REASON_FOR_APPROVAL')
                    : type == 2
                      ? this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.REASON_FOR_REJECTION')
                      : this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.COMMENTS_OPTIONAL'),
            btnText:
                type == 1
                    ? this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.APPROVE')
                    : type == 2
                      ? this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.REJECT')
                      : this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.ACKNOWLEDGE'),
        };
        let dialogRef = this.modelService.open(ApproveActionsModalComponent, {
            size: 'lg',
        });
        dialogRef.componentInstance.data = data;
        dialogRef.componentInstance.actionType = type;
        dialogRef.componentInstance.displayData = displayData;
        dialogRef.componentInstance.saveActions.subscribe((data: any) => {
            if (data) {
                this.saveAction(data);
            }
        });
    }
    async saveAction(payLoad: any) {
        this.ngxUiLoaderService.start();
        let response = await this.idmApiService.saveActions(payLoad).toPromise();
        if (!response || !response?.success) {
            this.customToastService.errorToast(response?.message ?? this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.ERROR_WHILE_SAVE'), 'Error');
            this.ngxUiLoaderService.stop();
            //         return null;
        } else {
            let message =
                payLoad.actionType == 1
                    ? payLoad?.itemType + ' ' + this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.APPROVED')
                    : payLoad.actionType == 2
                      ? payLoad?.itemType + ' ' + this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.REJECTED')
                      : payLoad?.itemType + ' ' + this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.ACKNOWLEDGED');
            this.customToastService.successToast(response?.message ?? message, 'Success');
            this.ngxUiLoaderService.stop();

            this.updateList.emit(true);
            this.modelService.dismissAll();
        }
    }
}
